<p-columnFilter
  #dtfc
  field="{{ field }}"
  display="menu"
  matchMode="between"
  [showMatchModes]="false"
  [showOperator]="false"
  [showApplyButton]="false"
  [showAddButton]="false"
  [showClearButton]="false"
>
  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
    <div style="display: flex;" (keydown.enter)="applyCalendarFilter(filter, dtfc)">
      <div>
        <div class="filter-label">
          {{ 'label.common.date-picker.from' | translate}}
        </div>
        <div>
          <p-calendar class="filter-date-ui-filter-mode"
            [(ngModel)]="startDate"
            [touchUI]="true"
            inputId="startDate"
            [readonlyInput]="true"
            dateFormat="{{returnDateFormat()}}"
          ></p-calendar>
        </div>
      </div>
      <div style="padding-left: 3px;">
        <div class="filter-label">
          {{ 'label.common.date-picker.to' | translate}}
        </div>
        <div>
          <p-calendar class="filter-date-ui-filter-mode"
            [(ngModel)]="endDate"
            [touchUI]="true"
            inputId="endDate"
            [readonlyInput]="true"
            dateFormat="{{returnDateFormat()}}"
          ></p-calendar>
        </div>
      </div>
    </div>
    <div class="table-column-filter-buttonbar">
      <button pButton (click)="clearFilter(dtfc)" label="Clear" class="filter-button p-element p-button-outlined p-button-sm">
      </button>
      <button pButton [disabled]="disableApplyButton()" label="Apply" (click)="applyCalendarFilter(filter, dtfc)" class="filter-button p-element p-button-sm">
      </button>
    </div>
  </ng-template>
</p-columnFilter>
